'use client';

import styled from '@emotion/styled';
import { ParkingBookingWidgetForm } from './ParkingBookingWidgetForm';
import { Css, ITheme, Responsive } from '../../../ui';
import { Color } from '../../../styles/Color';
import { Z_INDEX_PARKING_BOOKING_WIDGET } from '../../../styles/zIndex';
import { AirportCodesWithParkingBooking } from '../domain/models/AirportParkingBookingRoute';

const ParkingBookingWidgetWrapper = styled.div<{}, ITheme>`
	position: relative;
	display: flex;
	flex-direction: column;
	background: ${(props) => props.theme.background?.default};
	border: 1px solid ${Color.BorderCard};
	border-radius: 8px;
	padding: ${Css.pxToRem(32)};
	margin-top: -${Css.pxToRem(192)};

	height: fit-content;

	margin-bottom: ${Css.pxToRem(80)};
	z-index: ${Z_INDEX_PARKING_BOOKING_WIDGET};
	width: 95%;

	@media (${Responsive.getMediaQueryForBreakpoint('tablet')}) {
		padding: ${Css.pxToRem(24)};
		gap: ${Css.pxToRem(16)};
		margin-top: -${Css.pxToRem(96)};
		margin-bottom: ${Css.pxToRem(16)};
		width: 100%;
		height: auto;
	}
`;

interface IProps {
	airportCode: AirportCodesWithParkingBooking;
}

export const ParkingBookingWidget = ({ airportCode }: IProps) => (
	<ParkingBookingWidgetWrapper>
		<h4>Book your parking</h4>
		<ParkingBookingWidgetForm airportCode={airportCode} />
	</ParkingBookingWidgetWrapper>
);
